var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 27.76C16.5288 27.9163 16.2676 28.0003 15.9997 28.0003C15.7318 28.0003 15.4706 27.9163 15.253 27.76C8.81437 23.1707 1.98104 13.7307 8.88904 6.90933C10.7855 5.0438 13.3395 3.99883 15.9997 4C18.6664 4 21.225 5.04667 23.1104 6.908C30.0184 13.7293 23.185 23.168 16.7464 27.76Z",
    stroke: "#FFB85C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 16C16.7069 16 17.3852 15.7191 17.8853 15.219C18.3854 14.7189 18.6663 14.0406 18.6663 13.3334C18.6663 12.6261 18.3854 11.9478 17.8853 11.4477C17.3852 10.9476 16.7069 10.6667 15.9997 10.6667C15.2924 10.6667 14.6142 10.9476 14.1141 11.4477C13.614 11.9478 13.333 12.6261 13.333 13.3334C13.333 14.0406 13.614 14.7189 14.1141 15.219C14.6142 15.7191 15.2924 16 15.9997 16Z",
    stroke: "#FFB85C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f2c75bba39e8ec23dc2efc85f7d0c756.svg";
export { ForwardRef as ReactComponent };